import { ReactLenis } from "lenis/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { EnquiryProvider } from "@/components/EnquiryDialog";
import Home from "@/pages/Home";
import Courses from "@/pages/Courses";
import QualifiAesthetics from "@/pages/QualifiAesthetics";
import QualifiEducation from "@/pages/QualifiEducation";
import CPDCourse, { CPDCoursesList } from "@/pages/CPDCourse";
import About from "@/pages/About";
import Payment from "@/pages/Payment";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import "@/App.css";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App grain min-h-screen bg-navy">
        <BrowserRouter>
          <EnquiryProvider>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/courses/aesthetics" element={<QualifiAesthetics />} />
                <Route path="/courses/education" element={<QualifiEducation />} />
                <Route path="/courses/cpd" element={<CPDCoursesList />} />
                <Route path="/courses/cpd/:slug" element={<CPDCourse />} />
                <Route path="/about" element={<About />} />
                <Route path="/payment-options" element={<Payment />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
              </Routes>
            </main>
            <Footer />
          </EnquiryProvider>
        </BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#111d2e",
              border: "1px solid rgba(201,168,118,0.3)",
              color: "#fff",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
